/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Chip_OffInputs */



/**
* | output |
* | --- |
* | "Billing off" |
*
* @param {Partner_Admin_Billing_Chip_OffInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_chip_off = /** @type {((inputs?: Partner_Admin_Billing_Chip_OffInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Chip_OffInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechnung aus")
	return /** @type {LocalizedString} */ ("Billing off")
});